<div class="sign-info" *ngIf="shouldShowInfo">
  <ng-container *ngIf="hasSignInfo(signDetail)">
    <p *ngIf="!!otherSideSignDetail">
      <b>{{ capitalizedType }} bord links info:</b>
      {{ getSignInfo(signDetail) }}
    </p>
    <p *ngIf="!otherSideSignDetail">
      <b>{{ capitalizedType }} bord info:</b> {{ getSignInfo(signDetail) }}
    </p>
  </ng-container>

  <ng-container *ngIf="hasSignInfo(otherSideSignDetail)">
    <p>
      <b>{{ capitalizedType }} bord rechts info:</b>
      {{ getSignInfo(otherSideSignDetail) }}
    </p>
  </ng-container>

  <ng-container *ngIf="hasStickerInfo(signStickerDetail)">
    <p *ngIf="!!otherSideSignStickerDetail">
      <b>{{ capitalizedType }} sticker links info:</b>
      {{ getStickerInfo(signStickerDetail) }}
    </p>
    <p *ngIf="!otherSideSignStickerDetail">
      <b>{{ capitalizedType }} sticker info:</b>
      {{ getStickerInfo(signStickerDetail) }}
    </p>
  </ng-container>

  <ng-container *ngIf="hasStickerInfo(otherSideSignStickerDetail)">
    <p>
      <b>{{ capitalizedType }} sticker rechts info:</b>
      {{ getStickerInfo(otherSideSignStickerDetail) }}
    </p>
  </ng-container>
</div>
